<template>
    <div>
        <handover-form
            v-if="formId && formType === 'handover'"
            :form-id="formId"
        />
        <fire-alarm-test-form v-if="formId && formType === 'fire_alarm_test'" />
        <fire-alarm-test-form-2 v-if="formId && formType === 'fire_alarm_test_2'" />
        <fire-alarm-certificate v-if="formType === 'fire_alarm_certificate'" />
        <elighting-form v-if="formType === 'elighting'" />
        <elighting-certificate v-if="formType === 'elighting_certificate'" />
        <fire-ex-service v-if="formType === 'fire_ex_service'" />
        <fire-ex-certificate v-if="formType === 'fire_ex_certificate'" />
        <aldi-form v-if="formType === 'aldi'" />
        <take-over-form v-if="formType === 'take_over'" />
        <recommendations-form v-if="formType === 'recommendations'" />
        <zf-form v-if="formType === 'zf_form'" />
        <intruder-alarm-service v-if="formType === 'intruder_alarm_service'" />
        <weekly-functional-test v-if="formType === 'weekly_functional_test'" />
        <fire-training-form v-if="formType === 'fire_training'" />
        <fire-risk-assessment-form v-if="formType === 'fire_risk_assessment'" />
        <nurse-call-form v-if="formType === 'nurse_call'" />
        <fire-alarm-variations v-if="formType === 'fire_alarm_variations'" />
        <fire-alarm-commissioning-form v-if="formType === 'fire_alarm_commissioning'" />
        <fire-alarm-commissioning-certificate-form v-if="formType === 'fire_alarm_commissioning_certificate'" />
        <domestic-fire-alarm-service v-if="formType === 'domestic_fire_alarm_service'" />
        <fire-door-inspection v-if="formType === 'fire_door_inspection'" />
    </div>
</template>

<script>
import HandoverFromComponent from "./HandoverFormComponent.vue";
import FireAlarmTestFormComponent from "./FireAlarmTestFormComponent.vue";
import FireAlarmTestForm2Component from "./FireAlarmTestForm2Component.vue";
import FormService from "../../services/FormService";
import FireAlarmCertificateComponent from "./FireAlarmCertificateComponent.vue";
import ELightingFormComponent from "./ELightingFormComponent.vue";
import ELightingCertificateComponent from "./ELightingCertificateComponent";
import FireExServiceComponent from "./FireExServiceComponent";
import FireExCertificateComponent from "./FireExCertificateComponent.vue";
import UsesErrors from "../../mixins/UsesErrors";
import AldiFormComponent from "./AldiFormComponent";
import TakeOverForm from './TakeOverFormComponent';
import RecommendationsForm from './RecommendationsFormComponent';
import ZFForm from './ZFFormComponent';
import IntruderAlarmServiceForm from './IntruderAlarmServiceForm';
import WeeklyFunctionalForm from './WeeklyFunctionalTest';
import FireTrainingForm from './FireTrainingForm.vue';
import FireRiskAssessmentForm from './FireRiskAssessment';
import NurseCallForm from "./NurseCallForm.vue";
import FireAlarmVariationsComponent from "./FireAlarmVariationsComponent.vue";
import FireAlarmCommissioningComponent from "./FireAlarmCommissioningComponent.vue";
import FireAlarmCommissioningCertificateComponent from "./FireAlarmCommissioningCertificateComponent.vue";
import DomesticFireAlarmServiceComponent from "./DomesticFireAlarmServiceComponent.vue";
import FireDoorInspection from "./FireDoorInspection.vue";

export default {
    components: {
        FireDoorInspection,
        'fire-alarm-variations': FireAlarmVariationsComponent,
        'handover-form': HandoverFromComponent,
        'fire-alarm-test-form': FireAlarmTestFormComponent,
        'fire-alarm-test-form-2': FireAlarmTestForm2Component,
        'fire-alarm-certificate': FireAlarmCertificateComponent,
        'elighting-form': ELightingFormComponent,
        'elighting-certificate': ELightingCertificateComponent,
        'fire-ex-service': FireExServiceComponent,
        'fire-ex-certificate': FireExCertificateComponent,
        'aldi-form': AldiFormComponent,
        'take-over-form': TakeOverForm,
        'recommendations-form': RecommendationsForm,
        'zf-form': ZFForm,
        'intruder-alarm-service': IntruderAlarmServiceForm,
        'weekly-functional-test': WeeklyFunctionalForm,
        'fire-training-form': FireTrainingForm,
        FireRiskAssessmentForm,
        NurseCallForm,
        'fire-alarm-commissioning-form': FireAlarmCommissioningComponent,
        'fire-alarm-commissioning-certificate-form': FireAlarmCommissioningCertificateComponent,
        'domestic-fire-alarm-service': DomesticFireAlarmServiceComponent,
    },
    mixins: [UsesErrors],
    data: function () {
        return {
            formId: null,
            formType: null,
        }
    },
    mounted: function () {
        this.formId = this.$route.params.id;
        FormService.get(this.formId).then(xhr => {
            this.formType = xhr.data.type;
        }, () => {
            this.setErrorMessage('Could not load form');
        });
    },
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/EditComponent.vue